import { render, staticRenderFns } from "./material-box-list.vue?vue&type=template&id=51aa22ca&scoped=true"
import script from "./material-box-list.vue?vue&type=script&lang=js"
export * from "./material-box-list.vue?vue&type=script&lang=js"
import style0 from "./material-box-list.vue?vue&type=style&index=0&id=51aa22ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aa22ca",
  null
  
)

export default component.exports